import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {VisitPlanHttpService} from "../../angular/services/visit-plan-http.service";

export class SchedulingProjectTemplatesMultiSelectListComponent implements IController {
  selectedIds: any;
  optionIds: any;
  excludeIds: any;
  onChange: Function;

  public queryString: any;
  public selectedKeys: any;
  public excludeKeys: any;
  public isSelectAll: boolean;
  public templates: any[];
  public templatesCopy: any[];
  public isLoading: boolean;

  /* @ngInject */
  constructor(private $log: angular.ILogService, private $timeout: angular.ITimeoutService, private visitPlanHttpService: VisitPlanHttpService, private commonsService: CommonsService) {
  }

  $onInit() {
    this._getTemplates();
  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      });
    }

    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      });
    }
  }

  private _getTemplates() {
    this.isLoading = true;
    // We fetch a large limit to allow local filtering
    this.visitPlanHttpService.getAllTemplates(1000).subscribe({
      next: (response) => {
        this.$timeout(() => {
          this.templates = angular.copy(response.list);
          this.templatesCopy = angular.copy(response.list);
          this.isLoading = false;
        });
      },
      error: (error) => {
        this.$timeout(() => {
          this.$log.error('Failed to get templates', error);
          this.isLoading = false;
        });
      }
    });
  }

  onToggle(templateId, isSelected) {
    this.onChange({
      templateIds: isSelected ? _.concat(this.selectedIds || [], [templateId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== templateId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
    if (!query) {
      this.templatesCopy = this.templates;
    } else {
      this.templatesCopy = this.templates.filter(item =>
        item.name && item.name.toLowerCase().includes(query.toLowerCase())
      );
    }
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({templateIds: []});
    } else {
      this.onChange({templateIds: this.templates.map(t => t.id)});
    }
    this.isSelectAll = !this.isSelectAll;
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .component('schedulingProjectTemplatesMultiSelectList', {
    bindings: {
      selectedIds: '<',
      optionIds: '<?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./scheduling-project-templates-multi-select-list.html').default,
    controller: SchedulingProjectTemplatesMultiSelectListComponent
  });
